import { Bullseye, Spinner } from '@patternfly/react-core';
import React from 'react';

const CenteredSpinner = () => {
  return (
    <Bullseye>
      <Spinner aria-label="Loading..." />
    </Bullseye>
  );
};

export default CenteredSpinner;
